import { format, isValid, parseISO } from 'date-fns';

export const safeFormatDate = (
  dateValue: string | Date | null | undefined,
  formatStr: string = 'MMM d, yyyy',
  fallback: string = '-'
): string => {
  if (!dateValue) return fallback;
  try {
    const date = typeof dateValue === 'string' ? parseISO(dateValue) : dateValue;
    return isValid(date) ? format(date, formatStr) : fallback;
  } catch {
    return fallback;
  }
};
